var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripeDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "SVGInline-svg SVGInline--cleaned-svg SVG-svg BrandIcon-svg BrandIcon--size--32-svg",
    height: 32,
    width: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "#ebf1f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 17.9h-1.068l-1.203-1.53h-.114v1.53h-.871v-3.8h1.286c1.006 0 1.586.4 1.586 1.12 0 .59-.363.97-1.016 1.09zm-1.286-2.65c0-.37-.29-.56-.83-.56h-.27v1.15h.25c.56 0 .85-.2.85-.59zm-5.02-1.15h2.469v.64h-1.597v.85H26.1v.65h-1.535v1.03h1.597v.64h-2.468zm-2.8 3.9-1.887-3.91h.954l1.193 2.56 1.203-2.56h.933L21.382 18h-.466zm-7.891-.01c-1.327 0-2.364-.87-2.364-2 0-1.1 1.057-1.99 2.385-1.99.373 0 .684.07 1.068.23v.88a1.586 1.586 0 0 0-1.089-.43c-.83 0-1.462.58-1.462 1.31 0 .77.622 1.32 1.503 1.32.395 0 .695-.12 1.048-.42v.88c-.394.16-.726.22-1.089.22zm-2.634-1.25c0 .74-.633 1.25-1.545 1.25-.664 0-1.141-.22-1.545-.72l.57-.47c.197.34.529.51.944.51.394 0 .674-.23.674-.53 0-.17-.083-.3-.26-.4a3.693 3.693 0 0 0-.601-.22c-.82-.25-1.1-.52-1.1-1.05 0-.62.602-1.09 1.39-1.09.498 0 .944.15 1.317.43l-.456.5a.97.97 0 0 0-.705-.3c-.373 0-.643.18-.643.42 0 .2.155.31.674.48.996.3 1.286.58 1.286 1.2zM6.086 14.1h.871v3.81h-.871zm-2.8 3.81H2V14.1h1.286c1.41 0 2.385.78 2.385 1.9 0 .57-.29 1.11-.798 1.47-.436.3-.923.44-1.597.44zm1.016-2.86c-.29-.22-.622-.3-1.192-.3h-.24v2.52h.239c.56 0 .912-.1 1.192-.3.301-.24.477-.6.477-.97s-.176-.72-.477-.95z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 14c-1.1 0-2 .88-2 1.97 0 1.16.86 2.03 2 2.03 1.12 0 2-.88 2-2s-.87-2-2-2z",
    fill: "#f27712"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeDiscover);
export default __webpack_public_path__ + "static/media/stripe_discover.d3c0d2e569417e9883fa63dddf05db03.svg";
export { ForwardRef as ReactComponent };